import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import MUIButton from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'


const styles = theme => ({
  root: {
    position: 'relative',
  },
  margin: {
    marginTop: theme.spacing(1),
  },
  underline: {
    height: 1,
    bottom: 5,
    width: 0,
    position: 'absolute',
    transition: 'width 0.2s ease-in-out',
    backgroundColor: theme.palette.primary.main,
  },
  text: {
    '&:hover': {
      backgroundColor: 'transparent',

      '& $underline': {
        width: '90%',
      },
    },
  },
})


const Button = ({
  margin,
  classes,
  children,
  disabled,
  isLoading,
  className,
  disableUnderline,
  ...props
}) => {
  return (
    <MUIButton
      variant="contained"
      disabled={disabled || isLoading}
      className={classNames(classes.root, {
        [classes.margin]: margin,
      }, className)}
      classes={{
        text: classes.text,
      }}
      {...props}
    >
      {isLoading && <CircularProgress size={16} className="mr1" />}
      {children}
    </MUIButton>
  )
}


Button.propTypes = {
  margin: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  variant: PropTypes.string,
  className: PropTypes.string,
  disableUnderline: PropTypes.bool,
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(Button)
